<template>
  <div class="login-control">
    <div v-if="!hideHeader" class="text-left">
      <label>{{name}}</label>
    </div>
    <div class="d-flex">
      <input
        class="form-control login-input"
        :type="inputType"
        :placeholder="placeholder"
        :value="value"
        :invalid="invalid"
        @input="$emit('input', $event.target.value)"
        @focusout="onFocusout"
      />
      <div class="eye-toggle" v-if="eyeShowed" @click="showPassword = !showPassword">
          <cms-icon width="15" height="15">
            <eye-blocked v-if="showPassword" />
            <eye-open v-else />
          </cms-icon>
        </div>
    </div>
    <span class="validation-result" v-if="invalid">{{validationMessage}}</span>
  </div>
</template>

<script>
import validationRules from "../mixins/validationRules";
import eyeOpen from "./icons/eye-open";
import eyeBlocked from "./icons/eye-blocked";

export default {
  name: "loginInput",
  mixins: [validationRules],
  props: [
    "name",
    "placeholder",
    "type",
    "value",
    "validatePassword",
    "hideHeader",
    "eyeToggle"
  ],
  components: {
    "eye-open": eyeOpen,
    "eye-blocked": eyeBlocked,
  },
  data() {
    return {
      _validationVisible: false,
      showPassword: false
    };
  },
  computed: {
    $valid() {
      return !this.validationMessage;
    },
    invalid() {
      return this.$data._validationVisible && !this.$valid;
    },
    validationMessage() {
      if (this.isEmpty()) {
        return `The ${this.name} field is required.`;
      }
      
      if (this.maxlength && this.exceedsMaxLength()) {
        return `The ${this.name} length should not exceed ${this.maxlength} characters.`;
      }
      
      if (this.type === "email" && !this.isEmail()) {
        return `The ${this.name} is invalid.`;
      }
      
      if (
        this.type === "password" &&
        this.validatePassword &&
        !this.isCmsPassword
      ) {
        return `The ${this.name} must be at least 8 characters with 1 upper case letter, 1 lower case letter, and 1 number.`;
      }
    },
    eyeShowed() {
      return (
        this.type === "password" &&
        this.eyeToggle === true
      );
    },
    inputType() {
      if (this.type === "password" && this.showPassword) {
        return "text";
      }
      return this.type;
    }
  },
  methods: {
    onFocusout() {
      this.$showValidation();
      this.$emit("focusout");
    },
    $showValidation() {
      this.$data._validationVisible = true;
    },
    resetValidation() {
      this.$data._validationVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.login-control {
  margin-top: 8px;
  text-align: left;

  .login-input {
    height: 2.9rem;
    border-radius: 3px;
    border-color: #d1d1d1;
    background-color: white;
    font-size: 1rem;
    letter-spacing: -0.5px;
    color: #161719;
    box-shadow: none;

    &[invalid="true"] {
      border: solid 1px $coral-color;
    }
  }

  label {
    margin-bottom: 4px;
    margin-left: 0.8rem;
    color: #374249;
  }

  .validation-result {
    color: $coral-color;
    font-size: 0.8rem;
  }

  .eye-toggle{
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: solid #ced4da;
    border-bottom-left-radius:0px;
    border-bottom-right-radius:3px;
    border-top-left-radius:0px;
    border-top-right-radius:3px;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-left-width: 0;
    border-right-width: 1px;
    background-color:$white-one-color;
    padding:4px;
    color: $warm-grey-one-color;
  }
}
</style>

